import { useEffect, useState } from 'react';

export function useShellHeaderHeight(): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const setup = (): (() => void) | undefined => {
      const header = document.querySelector<HTMLElement>('[data-app-shell-header]');
      if (!header) return undefined;

      const measure = () => {
        setHeight(header.getBoundingClientRect().height);
      };

      measure();

      const resizeObserver =
        typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;

      resizeObserver?.observe(header);
      window.addEventListener('resize', measure, { passive: true });

      return () => {
        resizeObserver?.disconnect();
        window.removeEventListener('resize', measure);
      };
    };

    const cleanupRef: { current?: () => void } = {};

    const applySetup = () => {
      const cleanup = setup();
      if (cleanup) {
        cleanupRef.current = cleanup;
        return true;
      }
      return false;
    };

    if (applySetup()) {
      return () => {
        cleanupRef.current?.();
      };
    }

    const raf = requestAnimationFrame(() => {
      if (!cleanupRef.current) {
        applySetup();
      }
    });

    return () => {
      cancelAnimationFrame(raf);
      cleanupRef.current?.();
    };
  }, []);

  return height;
}
